import Rx from 'rxjs/Rx';

export default class RegisterService {
  constructor($http, host) {
    this.http = $http;
    this.host = host;
  }

  isEmailAvailability(email) {
    return Rx.Observable.fromPromise(this.http({
      method: 'GET',
      url: this.host + '/api/users/check-email',
      params: { email: email }
    }).then(
      (resp) => !resp.data.exists,
      (resp) => false
    ));
  }

  register(name, email, password) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/users',
      data: {name: name, email: email, password: password}
    }).then(
      (resp) => resp.data,
      (resp) => resp.data
    ));
  }

  registerAccount(name, country, identification, address, phone) {
    return Rx.Observable.fromPromise(this.http({
      method: 'POST',
      url: this.host + '/api/accounts',
      data: {
        company: name,
        country: country,
        identification: identification, 
        address: address, 
        phone: phone
      }
    }).then(
      (resp) => resp.data,
      (resp) => undefined
    ));
  }
}

 RegisterService.$inject = ['$http', 'host'];



// WEBPACK FOOTER //
// ./src/app/services/register.service.js